/* dashboard-rediseno (15-oct-2026): LA VENTANA H1, "RENAME DOCUMENT".

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Titulo "Rename document", etiqueta "Name" (la de hoy de la ventana de fotos), el campo con el
   nombre de hoy seleccionado (borde naranja con foco, 16 px en el telefono) y "Cancel" y "Save"
   (las llaves de hoy). Los errores van en rojo debajo del campo, con borde rojo y "Save" apagado,
   y salen de `errorDelNombre`: la MISMA regla del servidor. Si el nombre de hoy ya pasa de 120,
   la ventana abre con el error a la vista.

   Save: si la app perdio la red, sale "You need a connection" y la ventana se queda (`sinRed`
   se pregunta al tocar, no al abrir). Si no, `alGuardar(texto)`; bien: la ventana se cierra
   sin aviso de exito (el nombre cambia en su lugar, lo hace el Panel); mal: el error del
   servidor va debajo del campo, en rojo, y la ventana se queda. Un `error_code` conocido se dice
   por `common:errors.<codigo>`; el 429, con el aviso del freno de hoy; sin respuesta, "You need
   a connection"; cualquier otro, el aviso generico de hoy. */
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { errorDelNombre } from '../../lib/renombrarDocumento';
import VentanaDelPanel, { BOTON_VENTANA_PRINCIPAL, BOTON_VENTANA_SECUNDARIO } from './VentanaDelPanel';

export const AVISO_SIN_RED_ID = 'sin-conexion-borrar';

export function textoDelError(err, t, existe) {
  const status = err && err.response ? err.response.status : null;
  const codigo = err && err.response && err.response.data ? err.response.data.error_code : null;
  if (status === 429) return t('common:errors.rate_limit_generic');
  if (codigo && typeof existe === 'function' && existe(`common:errors.${codigo}`)) return t(`common:errors.${codigo}`);
  if (!err || !err.response) return t('common:offline.need_connection');
  return t('common:toasts.generic_error');
}

export default function VentanaRenombrar({ nombreActual, alGuardar, alCerrar, sinRed, t, existe, volverA }) {
  const [valor, setValor] = useState(typeof nombreActual === 'string' ? nombreActual : '');
  const [guardando, setGuardando] = useState(false);
  const [errorServidor, setErrorServidor] = useState(null);
  const campo = useRef(null);

  useEffect(() => {
    const c = campo.current;
    if (c) {
      if (typeof c.focus === 'function') c.focus();
      if (typeof c.select === 'function') c.select();
    }
  }, []);

  const codigo = errorDelNombre(valor);
  const error = codigo ? t(`common:errors.${codigo}`) : errorServidor;
  const conError = !!error;

  const guardar = async () => {
    if (codigo || guardando) return;
    if (typeof sinRed === 'function' && sinRed()) {
      toast.error(t('common:offline.need_connection'), { id: AVISO_SIN_RED_ID });
      return;
    }
    setGuardando(true);
    setErrorServidor(null);
    try {
      await alGuardar(valor);
    } catch (err) {
      setErrorServidor(textoDelError(err, t, existe));
      setGuardando(false);
    }
  };

  return (
    <VentanaDelPanel
      titulo={t('dashboard:panel.renombrar_titulo')}
      alCerrar={alCerrar}
      volverA={volverA}
      testid="ventana-renombrar"
      etiquetaId="ventana-renombrar-titulo"
      botones={(
        <>
          <button type="button" onClick={alCerrar} className={BOTON_VENTANA_SECUNDARIO} data-testid="renombrar-cancelar">
            {t('common:cancel')}
          </button>
          <button type="button" onClick={guardar} disabled={!!codigo || guardando} className={BOTON_VENTANA_PRINCIPAL} data-testid="renombrar-guardar">
            {guardando ? <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> : null}
            {t('common:save')}
          </button>
        </>
      )}
    >
      <form onSubmit={(e) => { e.preventDefault(); guardar(); }}>
        <label htmlFor="renombrar-campo" className="block text-[13px] font-medium text-[#9A9A9A] mb-1.5">{t('dashboard:fotos.nombre_label')}</label>
        <input
          id="renombrar-campo"
          ref={campo}
          type="text"
          name="nombre"
          autoComplete="off"
          value={valor}
          onChange={(e) => { setValor(e.target.value); setErrorServidor(null); }}
          aria-invalid={conError || undefined}
          aria-describedby={conError ? 'renombrar-error' : undefined}
          className={`w-full h-11 px-3.5 rounded-xl bg-[#0E0E0E] border text-[16px] md:text-[14px] text-[#F4F4F3] outline-none ${conError ? 'border-[#F87171]' : 'border-[#262626] focus:border-[#F27A2E]'}`}
          data-testid="renombrar-campo"
        />
        {conError ? (
          <p id="renombrar-error" role="alert" className="mt-2 text-[13px] leading-[18px] text-[#F87171]" data-testid="renombrar-error">{error}</p>
        ) : null}
      </form>
    </VentanaDelPanel>
  );
}
